module.exports = (file) => require('src/pages/' + file + '.js')



// WEBPACK FOOTER //
// src/helper/import/import.test.js